import React from 'react';
import PropTypes from 'prop-types';
import { Collapse as AntCollapse } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

const { Panel } = AntCollapse;

const Collapse = ({ 
  children,
  defaultActiveKey,
  activeKey,
  onChange,
  style,
  bordered = true,
  expandIconPosition = 'left',
  ...props 
}) => {
  const { theme } = useTheme();

  const collapseStyle = {
    backgroundColor: theme.white,
    border: bordered ? `1px solid ${theme.borderColor}` : 'none',
    borderRadius: '8px',
    ...style,
  };

  return (
    <AntCollapse
      defaultActiveKey={defaultActiveKey}
      activeKey={activeKey}
      onChange={onChange}
      style={collapseStyle}
      bordered={bordered}
      expandIconPosition={expandIconPosition}
      {...props}
    >
      {children}
    </AntCollapse>
  );
};

const CollapsePanel = ({ 
  header, 
  key, 
  children, 
  style,
  ...props 
}) => {
  const { theme } = useTheme();

  const panelStyle = {
    backgroundColor: theme.white,
    borderBottom: `1px solid ${theme.borderColor}`,
    ...style,
  };

  const headerStyle = {
    color: theme.textSecondary,
    fontWeight: 500,
  };

  return (
    <Panel
      header={<div style={headerStyle}>{header}</div>}
      key={key}
      style={panelStyle}
      {...props}
    >
      <div style={{ color: theme.textSecondary }}>
        {children}
      </div>
    </Panel>
  );
};

Collapse.Panel = CollapsePanel;

Collapse.propTypes = {
  children: PropTypes.node,
  defaultActiveKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  activeKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  onChange: PropTypes.func,
  style: PropTypes.object,
  bordered: PropTypes.bool,
  expandIconPosition: PropTypes.oneOf(['left', 'right']),
};

CollapsePanel.propTypes = {
  header: PropTypes.node.isRequired,
  key: PropTypes.string.isRequired,
  children: PropTypes.node,
  style: PropTypes.object,
};

export default Collapse; 